// src/hooks/useAuthCheck.js
import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../services/firebase/config';

export function useAuthCheck(user) {
  const [status, setStatus] = useState('loading');
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (!user) {
      setStatus('no-user');
      return;
    }

    const checkUser = async () => {
      try {
        const userDoc = await getDoc(doc(db, 'users', user.email));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setUserData(data);
          setStatus(data.membershipStatus || 'pending');
        } else {
          setStatus('error');
        }
      } catch (error) {
        console.error('Auth check error:', error);
        setStatus('error');
      }
    };

    checkUser();
  }, [user]);

  return { status, userData };
}